export interface ContactUsValues { name: string; email: string; subject: string; message: string; company: string; }
export const contactUsLimits = { name: 150, email: 254, subject: 200, message: 5000 };
// Reject non-text control characters while allowing tabs and multiline messages.
// eslint-disable-next-line no-control-regex
const invalidControls = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/;
export function validateContactUs(values: ContactUsValues): Record<string, string> {
    const errors: Record<string, string> = {};
    for (const [key, limit] of Object.entries(contactUsLimits)) {
        const value = values[key as keyof ContactUsValues];
        if (!value.trim()) errors[key] = 'This field is required.';
        else if (value.length > limit) errors[key] = `Use no more than ${limit} characters.`;
        else if (invalidControls.test(value) || (key !== 'message' && /[\r\n]/.test(value))) errors[key] = 'This field contains invalid characters.';
        else if (key === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) errors[key] = 'Enter a valid email address.';
    }
    return errors;
}
